var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-form',{staticClass:"payout-form__form __paypal mt-6",attrs:{"fields":_vm.fields,"values":_vm.values},on:{"input":_vm.input,"validation":function($event){return _vm.$emit('validation', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }